angular
  .module('contabilidad.reportenominasmovimientos')
  .service('ContabilidadReportenominasmovimientosExcel', ContabilidadReportenominasmovimientosExcel)

ContabilidadReportenominasmovimientosExcel.$inject = ['$http', '$export', '$window']

function ContabilidadReportenominasmovimientosExcel ($http, $export, $window) {
  this.exportar = exportarXLS

  function exportarXLS (busqueda) {
    if (busqueda.reporte === '2')
      return exportarDetalle(busqueda)
    else if (busqueda.reporte === '1')
      return exportarsinDetalle(busqueda)
    else if (busqueda.reporte === '3')
      return exportarPorCliente(busqueda)
  }

  function exportarsinDetalle (busqueda) {
    var pages = []
    var encabezados = [
      {label: 'Estado	', format: {width: 30}},
      {label: 'ID Operadora', format: {width: 10}},
      {label: 'Operadora', format: {width: 40}},
      {label: 'ID Empresa', format: {width: 10}},
      {label: 'Empresa', format: {width: 40}},
      {label: 'Fecha', format: {width: 10, align: 'right', type: 'date'}},
      {label: 'Fecha Pago', format: {width: 10, align: 'right', type: 'date'}},
      {label: 'ID Nomina', format: {width: 20}},
      {label: 'ID Concepto', format: {width: 15}},
      {label: 'Concepto', format: {width: 30}},
      {label: 'Empelados', format: {width: 20, align: 'right', type: 'number'}},
      {label: 'Total Timbrado', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Total No Timbrado', format: {width: 20, align: 'right', type: 'currency'}},
      {label: 'Total', format: {width: 20, align: 'right', type: 'currency'}},
    ]

    pages.push(new Page(encabezados, 'Nóminas'))
    busqueda.pages = pages
    return exportar(busqueda)
  }

  function exportarDetalle (busqueda) {
    var pages = []
    var encabezados = [
      {label: 'Estado	', format: {width: 30}},
      {label: 'ID Operadora', format: {width: 10}},
      {label: 'Operadora', format: {width: 40}},
      {label: 'ID Empresa', format: {width: 10}},
      {label: 'Empresa', format: {width: 40}},
      {label: 'Fecha', format: {width: 10, align: 'right', type: 'date'}},
      {label: 'Fecha Pago', format: {width: 10, align: 'right', type: 'date'}},
      {label: 'ID Nomina', format: {width: 20}},
      {label: 'Empleado', format: {width: 40}},
      {label: 'ID Concepto', format: {width: 15}},
      {label: 'Concepto', format: {width: 30}},
      {label: 'Total	', format: {width: 20, align: 'right', type: 'currency'}},
    ]

    pages.push(new Page(encabezados, 'Nóminas'))
    busqueda.pages = pages
    return exportar(busqueda)
  }

  function exportarPorCliente (busqueda) {
    var pages = []
    var encabezados = []

    pages.push(new Page(encabezados, 'Detalle por Cliente'))
    busqueda.pages = pages
    return exportar(busqueda)
  }

  function Page (encabezados, nombre) {
    return {
      name: nombre,
      columns: encabezados,
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'A8',
      },
    }
  }

  function exportar (busqueda) {
    return $http.post('/api/nominas/reportes/movimientos', busqueda, {
      responseType: 'arraybuffer',
      headers: {
        'X-HTTP-Method-Override': 'GET',
      },
    }).then(function (response) {

      var contentType = response.headers('Content-Type'),
        filename = /filename="([^"\\]*(?:\\.[^"\\]*)*)"/i.exec(response.headers('Content-Disposition'))

      var file = new File([response.data], 'Reporte de movimientos por nomina.xlsx', {type: contentType})

      var reader = new FileReader()

      reader.addEventListener('load', function () {
        $window.open(reader.result, '_blank')
      }, false)

      if (file) {
        reader.readAsDataURL(file)
      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/services/ReportenominasmovimientosExcel.js